import Vue from "vue";
import VueRouter from "vue-router";
import authenticate from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "login",
    meta: {
      title: "Login",
    },
    component: () => import("@/views/Login"),
  },
  {
    path: "/unsuscribe",
    name: "unsuscribe",
    meta: {
      title: "Unsuscribe",
    },
    component: () => import("@/views/unsuscribe"),
  },
  {
    path: "/mirror_view",
    name: "mirror_view",
    meta: {
      title: "Mirror View",
    },
    component: () => import("@/views/mirror_view"),
  },
  {
    path: "/mirror_views",
    name: "mirror_views",
    meta: {
      title: "Mirror Views",
    },
    component: () => import("@/views/mirror_view"),
  },
  {
    path: "/terms",
    name: "term",
    meta: {
      title: "Terms",
    },
    component: () => import("@/views/terms/Terms.vue"),
  },
  {
    path: "/privacy",
    name: "privacy-web",
    meta: {
      title: "Privacy",
    },
    component: () => import("@/views/terms/Privacy.vue"),
  },
  {
    path: "/delete_account",
    name: "delete_account",
    meta: {
      title: "Eliminar cuenta",
    },
    component: () => import("@/views/account/DeleteAccount/index.vue"),
  },
  {
    path: "/send-help",
    name: "send-help",
    meta: {
      title: "Ayuda",
    },
    component: () => import("@/views/help/SendHelp/index.vue"),
  },
  {
    path: "/admin",
    component: () => import("@/views/Admin/index.vue"),
    meta: {
      title: "Admin",
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "admin",
        meta: {
          title: "Login",
        },
        component: () => import("@/views/Admin/users_scroll/list.vue"),
      },
      {
        path: "profile",
        name: "profile",
        meta: {
          title: "Profile",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/profile/edit.vue"),
      },

      // User Enterprise
      {
        path: "user_enterprises",
        name: "user_enterprises",
        meta: {
          title: "Empresas usuarias",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/user_enterprises/list.vue"),
      },
      {
        path: "user_enterprises/edit/:id",
        name: "user_enterprises-edit",
        meta: {
          title: "Editar empresa usuaria",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/user_enterprises/form.vue"),
      },
      {
        path: "user_enterprises/add",
        name: "user_enterprises-add",
        meta: {
          title: "Añadir empresa usuaria",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/user_enterprises/form.vue"),
      },

      // Users
      {
        path: "users",
        name: "users",
        meta: {
          title: "Usuarios",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/list.vue"),
      },
      {
        path: "users/edit/:id",
        name: "users-edit",
        meta: {
          title: "Editar usuario",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/form.vue"),
      },
      {
        path: "users/add",
        name: "users-add",
        meta: {
          title: "Añadir usuario",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/form.vue"),
      },

      // Users --> Spots
      {
        path: "users/:user_id/spots",
        name: "users-spot",
        meta: {
          title: "Spots",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/spots/list.vue"),
      },
      {
        path: "users/:user_id/spots/edit/:id",
        name: "users-spot-edit",
        meta: {
          title: "Editar Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/spots/form.vue"),
      },
      {
        path: "users/:user_id/spots/add",
        name: "users-spot-add",
        meta: {
          title: "Añadir Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/spots/form.vue"),
      },

      // Users --> PushNotifications | Email
      {
        path: "users/:user_id/message/send/:spot_id",
        name: "users-message-send",
        meta: {
          title: "Send Message",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/spots/form_message.vue"),
      },
      // Users --> Spots -> AvailableDays
      {
        path: "users/:user_id/spots/:spot_id/available_days",
        name: "users-spots-availabledays",
        meta: {
          title: "Dias disponibles",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/users/spots/available_days/list.vue"),
      },
      {
        path: "users/:user_id/spots/:spot_id/available_days/edit/:id",
        name: "users-spots-availableday-edit",
        meta: {
          title: "Editar dias disponible",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/users/spots/available_days/form.vue"),
      },
      {
        path: "users/:user_id/spots/:spot_id/available_days/add",
        name: "users-spots-availableday-add",
        meta: {
          title: "Añadir dias disponible",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/users/spots/available_days/form.vue"),
      },
      // Users --> Spots -> Reviews
      {
        path: "users/:user_id/spots/:spot_id/reviews",
        name: "users-spots-reviews",
        meta: {
          title: "Dias disponibles",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/users/spots/reviews/list.vue"),
      },
      // Users --> Car
      {
        path: "users/:user_id/cars",
        name: "users-car",
        meta: {
          title: "Autos",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/cars/list.vue"),
      },
      {
        path: "users/:user_id/cars/edit/:id",
        name: "users-car-edit",
        meta: {
          title: "Editar auto",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/cars/form.vue"),
      },
      {
        path: "users/:user_id/cars/add",
        name: "users-car-add",
        meta: {
          title: "Añadir auto",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/cars/form.vue"),
      },

      // Users --> rent_orders
      {
        path: "users/:user_id/rent_orders",
        name: "users-rent_orders",
        meta: {
          title: "Estadias realizadas",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/rent_orders/list.vue"),
      },
      {
        path: "users/:user_id/rent_orders/edit/:id",
        name: "users-rent_order-edit",
        meta: {
          title: "Editar alquiler",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/rent_orders/form.vue"),
      },

      // Users_scroll
      {
        path: "users_scroll",
        name: "users_scroll",
        meta: {
          title: "Usuarios",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/list.vue"),
      },
      {
        path: "users_scroll/:id/fund_coins",
        name: "users_scroll-fund-coins",
        meta: {
          title: "Editar usuario",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/fund_coins/form.vue"),
      },
      {
        path: "users_scroll/edit/:id",
        name: "users_scroll-edit",
        meta: {
          title: "Editar usuario",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/form.vue"),
      },
      {
        path: "users_scroll/add",
        name: "users_scroll-add",
        meta: {
          title: "Añadir usuario",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/form.vue"),
      },

      // Users_scroll --> Spots
      {
        path: "users_scroll/:user_id/spots",
        name: "users_scroll-spot",
        meta: {
          title: "Spots",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/spots/list.vue"),
      },
      {
        path: "users_scroll/:user_id/spots/edit/:id",
        name: "users_scroll-spot-edit",
        meta: {
          title: "Editar Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/spots/form.vue"),
      },
      {
        path: "users_scroll/:user_id/spots/add",
        name: "users_scroll-spot-add",
        meta: {
          title: "Añadir Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/spots/form.vue"),
      },

      // Users_scroll --> Spots -> AvailableDays
      {
        path: "users_scroll/:user_id/spots/:spot_id/available_days",
        name: "users_scroll-spots-availabledays",
        meta: {
          title: "Dias disponibles",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/users_scroll/spots/available_days/list.vue"),
      },
      {
        path: "users_scroll/:user_id/spots/:spot_id/available_days/edit/:id",
        name: "users_scroll-spots-availableday-edit",
        meta: {
          title: "Editar dias disponible",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/users_scroll/spots/available_days/form.vue"),
      },
      {
        path: "users_scroll/:user_id/spots/:spot_id/available_days/add",
        name: "users_scroll-spots-availableday-add",
        meta: {
          title: "Añadir dias disponible",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/users_scroll/spots/available_days/form.vue"),
      },

      // Users_scroll --> Car
      {
        path: "users_scroll/:user_id/cars",
        name: "users_scroll-car",
        meta: {
          title: "Autos",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/cars/list.vue"),
      },
      {
        path: "users_scroll/:user_id/cars/edit/:id",
        name: "users_scroll-car-edit",
        meta: {
          title: "Editar auto",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/cars/form.vue"),
      },
      {
        path: "users_scroll/:user_id/cars/add",
        name: "users_scroll-car-add",
        meta: {
          title: "Añadir auto",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/cars/form.vue"),
      },

      // Users_scroll --> rent_orders
      {
        path: "users_scroll/:user_id/rent_orders",
        name: "users_scroll-rent_orders",
        meta: {
          title: "Estadias realizadas",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/rent_orders/list.vue"),
      },
      {
        path: "users_scroll/:user_id/rent_orders/edit/:id",
        name: "users_scroll-rent_order-edit",
        meta: {
          title: "Editar alquiler",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users_scroll/rent_orders/form.vue"),
      },

      // Deleted Users
      {
        path: "deleted_users",
        name: "deleted_users",
        meta: {
          title: "Usuarios eliminados",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/deleted_users/list.vue"),
      },

      // Deleted Users
      {
        path: "user_reports",
        name: "user_reports",
        meta: {
          title: "Usuarios Reportados",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/user_reports/list.vue"),
      },

      // Deleted Spots
      {
        path: "deleted_spots",
        name: "deleted_spots",
        meta: {
          title: "Spots eliminados",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/deleted_spots/list.vue"),
      },

      // Providers
      {
        path: "providers",
        name: "providers",
        meta: {
          title: "Proveedores",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/providers/list.vue"),
      },
      {
        path: "providers/edit/:id",
        name: "providers-edit",
        meta: {
          title: "Editar proveedor",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/providers/form.vue"),
      },
      {
        path: "providers/add",
        name: "providers-add",
        meta: {
          title: "Añadir proveedor",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/providers/form.vue"),
      },
      {
        path: "providers/show/:id",
        name: "providers-show",
        meta: {
          title: "Detalle Proveedor",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/providers/show.vue"),
      },

      // Provider -> Reviews
      {
        path: "providers/:provider_id/reviews",
        name: "reviews",
        meta: {
          title: "Reseñas",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/providers/reviews/list.vue"),
      },
      {
        path: "providers/:provider_id/reviews/add",
        name: "comfort-add",
        meta: {
          title: "Añadir reseña",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/providers/reviews/form.vue"),
      },
      {
        path: "providers/:provider_id/reviews/edit/:id",
        name: "comfort-edit",
        meta: {
          title: "Editar reseña",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/providers/reviews/form.vue"),
      },

      // Report User
      {
        path: "report_users",
        name: "report_users",
        meta: {
          title: "Usuarios Reportados",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/report_users/list.vue"),
      },
      {
        path: "report_users/edit/:id",
        name: "report_users-edit",
        meta: {
          title: "Editar usuario reportado",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/report_users/form.vue"),
      },
      {
        path: "report_users/add",
        name: "report_users-add",
        meta: {
          title: "Reportar user",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/report_users/form.vue"),
      },

      // Report Picture
      {
        path: "report_pictures",
        name: "report_pictures",
        meta: {
          title: "Imagenes Reportadas",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/report_pictures/list.vue"),
      },
      {
        path: "report_pictures/edit/:id",
        name: "report_pictures-edit",
        meta: {
          title: "Editar imagen reportada",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/report_pictures/form.vue"),
      },
      {
        path: "report_pictures/add",
        name: "report_pictures-add",
        meta: {
          title: "Reportar imagen",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/report_pictures/form.vue"),
      },

      // Job
      {
        path: "jobs",
        name: "jobs",
        meta: {
          title: "Trabajos",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/jobs/list.vue"),
      },
      {
        path: "jobs/edit/:id",
        name: "jobs-edit",
        meta: {
          title: "Editar trabajo",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/jobs/form.vue"),
      },
      {
        path: "jobs/add",
        name: "jobs-add",
        meta: {
          title: "Añadir trabajo",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/jobs/form.vue"),
      },

      // Speciality
      {
        path: "jobs/:job_id/specialities",
        name: "specialities",
        meta: {
          title: "Especialidades",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/jobs/specialities/list.vue"),
      },
      {
        path: "jobs/:job_id/specialities/add",
        name: "specialities-add",
        meta: {
          title: "Añadir especialidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/jobs/specialities/form.vue"),
      },
      {
        path: "jobs/:job_id/specialities/edit/:id",
        name: "specialities-edit",
        meta: {
          title: "Editar especialidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/jobs/specialities/form.vue"),
      },

      // Place
      {
        path: "places",
        name: "places",
        meta: {
          title: "Zonas habilitadas",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/places/list.vue"),
      },
      {
        path: "places/edit/:id",
        name: "places-edit",
        meta: {
          title: "Editar zona",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/places/form.vue"),
      },
      {
        path: "places/add",
        name: "places-add",
        meta: {
          title: "Añadir zona",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/places/form.vue"),
      },

      // Brands
      {
        path: "car_brands",
        name: "car_brands",
        meta: {
          title: "Marcas",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/car_brands/list.vue"),
      },
      {
        path: "car_brands/edit/:id",
        name: "car_brands-edit",
        meta: {
          title: "Editar marca",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/car_brands/form.vue"),
      },
      {
        path: "car_brands/add",
        name: "car_brands-add",
        meta: {
          title: "Añadir marca",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/car_brands/form.vue"),
      },

      // Brands --> Models
      {
        path: "car_brands/:brand_id/car_models",
        name: "car_brands-car_models",
        meta: {
          title: "Modelos",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/car_brands/car_models/list.vue"),
      },
      {
        path: "car_brands/:brand_id/car_models/edit/:id",
        name: "car_brands-car_models-edit",
        meta: {
          title: "Editar modelo",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/car_brands/car_models/form.vue"),
      },
      {
        path: "car_brands/:brand_id/car_models/add",
        name: "car_brands-car_models-add",
        meta: {
          title: "Añadir modelo",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/car_brands/car_models/form.vue"),
      },

      // Brands --> Models --> Colors
      {
        path: "car_brands/:brand_id/car_models/:model_id/car_colors",
        name: "car_brands-car_colors",
        meta: {
          title: "Colores",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/car_brands/car_models/car_colors/list.vue"),
      },
      {
        path: "car_brands/:brand_id/car_models/:model_id/car_colors/edit/:id",
        name: "car_brands-car_colors-edit",
        meta: {
          title: "Editar color",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/car_brands/car_models/car_colors/form.vue"),
      },
      {
        path: "car_brands/:brand_id/car_models/:model_id/car_colors/add",
        name: "car_brands-car_colors-add",
        meta: {
          title: "Añadir color",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/car_brands/car_models/car_colors/form.vue"),
      },
      // Amenities
      {
        path: "amenities",
        name: "amenities",
        meta: {
          title: "Comodidades",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/amenities/list.vue"),
      },
      {
        path: "amenities/edit/:id",
        name: "amenities-edit",
        meta: {
          title: "Editar comodidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/amenities/form.vue"),
      },
      {
        path: "amenities/add",
        name: "amenities-add",
        meta: {
          title: "Añadir comodidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/amenities/form.vue"),
      },
      // Type Spots
      {
        path: "type_spots",
        name: "type_spots",
        meta: {
          title: "Tipo de spots",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/type_spots/list.vue"),
      },
      {
        path: "type_spots/edit/:id",
        name: "type_spots-edit",
        meta: {
          title: "Edit tipo de Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/type_spots/form.vue"),
      },
      {
        path: "type_spots/add",
        name: "type_spots-add",
        meta: {
          title: "Añadir tipo de Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/type_spots/form.vue"),
      },

      // Coupons
      {
        path: "coupons",
        name: "coupons",
        meta: {
          title: "Cupones",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coupons/list.vue"),
      },
      {
        path: "coupons/edit/:id",
        name: "coupons-edit",
        meta: {
          title: "Editar cupon",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coupons/form.vue"),
      },
      {
        path: "coupons/add",
        name: "coupons-add",
        meta: {
          title: "Añadir cupon",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coupons/form.vue"),
      },
      {
        path: "coupons_bulk/add",
        name: "coupons-bulk-add",
        meta: {
          title: "Añadir cupon bulk",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coupons/formAssign.vue"),
      },
      // Coupons --> User Coupons
      {
        path: "coupons/:coupon_id/user_coupons",
        name: "user-coupon",
        meta: {
          title: "User coupons",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coupons/user_coupons/list.vue"),
      },
      {
        path: "coupons/:coupon_id/user_coupons/edit/:id",
        name: "user-coupon-edit",
        meta: {
          title: "Editar user coupons",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coupons/user_coupons/form.vue"),
      },
      {
        path: "coupons/:coupon_id/user_coupons/add",
        name: "user-coupon-add",
        meta: {
          title: "Añadir user coupons",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coupons/user_coupons/form.vue"),
      },
      // Privacy
      {
        path: "privacy",
        name: "privacy",
        meta: {
          title: "Política de Privacidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/privacy/list.vue"),
      },
      {
        path: "privacy/edit/:id",
        name: "privacy-edit",
        meta: {
          title: "Editar política de privacidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/privacy/form.vue"),
      },
      {
        path: "privacy/add",
        name: "privacy-add",
        meta: {
          title: "Añadir política de privacidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/privacy/form.vue"),
      },
      // Additional info
      {
        path: "additional_info",
        name: "additional_info",
        meta: {
          title: "Información Adicional",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/additional_info/list.vue"),
      },
      {
        path: "additional_info/edit/:id",
        name: "additional_info-edit",
        meta: {
          title: "Editar Información Adicional",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/additional_info/form.vue"),
      },
      {
        path: "additional_info/add",
        name: "additional_info-add",
        meta: {
          title: "Añadir Información Adicional",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/additional_info/form.vue"),
      },
      // Reporte de ayuda
      {
        path: "spot_helps",
        name: "spot_helps",
        meta: {
          title: "Reporte de Ayuda",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/spot_helps/list.vue"),
      },
      {
        path: "spot_helps/edit/:id",
        name: "spot_helps-edit",
        meta: {
          title: "Editar Reporte de Ayuda",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/spot_helps/form.vue"),
      },
      {
        path: "spot_helps/add",
        name: "spot_helps-add",
        meta: {
          title: "Añadir Reporte de Ayuda",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/spot_helps/form.vue"),
      },
      {
        path: "spot_helps/show/:id",
        name: "spot_helps-show",
        meta: {
          title: "Editar Reporte de Ayuda",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/spot_helps/show.vue"),
      },
      /* ---------------------------- spot help message --------------------------- */
      {
        path: "spot_helps/:spot_help_id/send_message/",
        name: "spots-help-message-send",
        meta: {
          title: "Send Message",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/spot_helps/form_message.vue"),
      },
      // App_ads
      {
        path: "app_ads",
        name: "app_ads",
        meta: {
          title: "Anuncios App",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/app_ads/list.vue"),
      },
      {
        path: "app_ads/edit/:id",
        name: "app_ads-edit",
        meta: {
          title: "Editar Anuncio App",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/app_ads/form.vue"),
      },
      {
        path: "app_ads/add",
        name: "app_ads-add",
        meta: {
          title: "Añadir Anuncio App",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/app_ads/form.vue"),
      },
      // Terms
      {
        path: "terms",
        name: "terms",
        meta: {
          title: "Terminos y Condiciones",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/terms/list.vue"),
      },
      {
        path: "terms/edit/:id",
        name: "terms-edit",
        meta: {
          title: "Editar terminos y condiciones",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/terms/form.vue"),
      },
      {
        path: "terms/add",
        name: "terms-add",
        meta: {
          title: "Añadir terminos y condiciones",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/terms/form.vue"),
      },

      // Tags
      {
        path: "tags",
        name: "tags",
        meta: {
          title: "Etiquetas",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/tags/list.vue"),
      },
      {
        path: "tags/edit/:id",
        name: "tags-edit",
        meta: {
          title: "Editar Etiqueta",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/tags/form.vue"),
      },
      {
        path: "tags/add",
        name: "tags-add",
        meta: {
          title: "Añadir Etiqueta",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/tags/form.vue"),
      },

      // Liquidations
      {
        path: "liquidations",
        name: "liquidations",
        meta: {
          title: "Liquidaciones",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/liquidations/list.vue"),
      },
      {
        path: "liquidations/edit/:id",
        name: "liquidations-edit",
        meta: {
          title: "Editar liquidaciones",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/liquidations/form.vue"),
      },
      {
        path: "liquidations/add",
        name: "liquidations-add",
        meta: {
          title: "Añadir liquidaciones",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/liquidations/new_liquidations.vue"),
      },

      // Provinces
      {
        path: "provinces",
        name: "provinces",
        meta: {
          title: "Provincias",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/provinces/list.vue"),
      },
      {
        path: "provinces/edit/:id",
        name: "province-edit",
        meta: {
          title: "Editar provincia",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/provinces/form.vue"),
      },
      {
        path: "provinces/add",
        name: "province-add",
        meta: {
          title: "Añadir provincia",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/provinces/form.vue"),
      },

      // Cities
      {
        path: "provinces/:province_id/cities",
        name: "cities",
        meta: {
          title: "Provincias",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/provinces/cities/list.vue"),
      },
      {
        path: "provinces/:province_id/cities/edit/:id",
        name: "province-city-edit",
        meta: {
          title: "Editar provincia",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/provinces/cities/form.vue"),
      },
      {
        path: "provinces/:province_id/cities/add",
        name: "province-city-add",
        meta: {
          title: "Añadir provincia",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/provinces/cities/form.vue"),
      },

      // Faqs
      {
        path: "faqs",
        name: "faqs",
        meta: {
          title: "FAQ's",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/faqs/list.vue"),
      },
      {
        path: "faqs/edit/:id",
        name: "faqs-edit",
        meta: {
          title: "Edit Faq",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/faqs/form.vue"),
      },
      {
        path: "faqs/add",
        name: "faqs-add",
        meta: {
          title: "Add Faq",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/faqs/form.vue"),
      },
      // Options
      {
        path: "options",
        name: "options",
        meta: {
          title: "Opciones",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/options/list.vue"),
      },
      {
        path: "options/edit/:id",
        name: "options-edit",
        meta: {
          title: "Editar opción",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/options/form.vue"),
      },
      {
        path: "options/add",
        name: "options-add",
        meta: {
          title: "Añadir opción",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/options/form.vue"),
      },
      // Answers
      {
        path: "answers",
        name: "answers",
        meta: {
          title: "Respuestas",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/answers/list.vue"),
      },
      // stay instructions
      {
        path: "stay_instructions",
        name: "stay_instructions",
        meta: {
          title: "Stay Instructions",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/stay_instructions/list.vue"),
      },
      {
        path: "stay_instructions/edit/:id",
        name: "stay_instructions-edit",
        meta: {
          title: "Edit Stay Instruction",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/stay_instructions/form.vue"),
      },
      {
        path: "stay_instructions/add",
        name: "stay_instructions-add",
        meta: {
          title: "Add Stay Instruction",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/stay_instructions/form.vue"),
      },
      // Coins
      {
        path: "coins",
        name: "coins",
        meta: {
          title: "Coins",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coins/list.vue"),
      },
      {
        path: "coins/edit/:id",
        name: "coins-edit",
        meta: {
          title: "Edit Coin",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coins/form.vue"),
      },
      {
        path: "coins/add",
        name: "coins-add",
        meta: {
          title: "Add Coin",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coins/form.vue"),
      },

      // Suggested Prices
      {
        path: "suggested_prices",
        name: "suggested_prices",
        meta: {
          title: "Precio Sugerido",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/suggested_prices/list.vue"),
      },
      {
        path: "suggested_prices/edit/:id",
        name: "suggested_prices-edit",
        meta: {
          title: "Edit Suggested Price",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/suggested_prices/form.vue"),
      },
      // Purchase Coins
      {
        path: "coin_purchases",
        name: "purchase-coins",
        meta: {
          title: "Purchase Coins",
          requiresAuth: false,
        },
        component: () => import("@/views/Admin/coin_purchases/list.vue"),
      },
      {
        path: "coin_purchases/add",
        name: "purchase-coins-add",
        meta: {
          title: "Add Purchase Coin",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coin_purchases/form.vue"),
      },
      {
        path: "coin_purchases/show/:id",
        name: "purchase-coin-show",
        meta: {
          title: "Ver Compra de coin",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coin_purchases/show.vue"),
      },
      // Coin Refunds
      {
        path: "coins_refunds",
        name: "coins-refunds",
        meta: {
          title: "Carga de Coins",
          requiresAuth: false,
        },
        component: () => import("@/views/Admin/coins_refunds/list.vue"),
      },
      {
        path: "coins_refunds/show/:id",
        name: "coins-refunds-show",
        meta: {
          title: "Ver carga de coin",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/coins_refunds/show.vue"),
      },
      //Push Notifications
      {
        path: "push_notifications",
        name: "push_notifications",
        meta: {
          title: "Notifications",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/push_notifications/list.vue"),
      },
      {
        path: "push_notifications/edit/:id",
        name: "push_notifications-edit",
        meta: {
          title: "Edit Notification",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/push_notifications/form.vue"),
      },
      {
        path: "push_notifications/add",
        name: "push_notifications-add",
        meta: {
          title: "Add Notification",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/push_notifications/form.vue"),
      },
      //Send Notifications
      {
        path: "send_notifications",
        name: "send_notifications",
        meta: {
          title: "Notifications",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/send_notifications/list.vue"),
      },
      {
        path: "send_notifications/edit/:id",
        name: "send_notifications-edit",
        meta: {
          title: "Edit Notification",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/send_notifications/form.vue"),
      },
      {
        path: "send_notifications/add",
        name: "send_notifications-add",
        meta: {
          title: "Add Notification",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/send_notifications/form.vue"),
      },
      //Notification Cms
      {
        path: "notifications_cms",
        name: "notifications_cms",
        meta: {
          title: "Nuevos Spots",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_cms/list.vue"),
      },
      {
        path: "notifications_cms/edit/:id",
        name: "notifications_cms-edit",
        meta: {
          title: "Edit Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_cms/form.vue"),
      },
      {
        path: "notifications_cms/show/:id",
        name: "notifications_cms-show",
        meta: {
          title: "Show Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_cms/show.vue"),
      },
      {
        path: "notifications_cms/add",
        name: "notifications_cms-add",
        meta: {
          title: "Add Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_cms/form.vue"),
      },
      //Spot reviews
      {
        path: "notifications_cms/:spot_id/reviews",
        name: "notifications_cms-reviews",
        meta: {
          title: "Reviews",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_cms/reviews/list.vue"),
      },

      // Users --> Spots -> AvailableDays
      {
        path: "notifications_cms/:spot_id/available_days",
        name: "notifications_cms-availabledays",
        meta: {
          title: "Dias disponibles",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/notifications_cms/available_days/list.vue"),
      },
      {
        path: "notifications_cms/:spot_id/available_days/edit/:id",
        name: "notifications_cms-availableday-edit",
        meta: {
          title: "Editar dias disponible",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/notifications_cms/available_days/form.vue"),
      },
      {
        path: "notifications_cms/:spot_id/available_days/add",
        name: "notifications_cms-availableday-add",
        meta: {
          title: "Añadir dias disponible",
          requiresAuth: true,
        },
        component: () =>
          import("@/views/Admin/notifications_cms/available_days/form.vue"),
      },


      /***notifications_request_cms */
      {
        path: "notifications_request_cms",
        name: "notifications_request_cms",
        meta: {
          title: "Nuevos Notifications CMS",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_request_cms/list.vue"),
      },
      {
        path: "notifications_request_cms/edit/:id",
        name: "notifications_request_cms-edit",
        meta: {
          title: "Edit Notifications CMS",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_request_cms/form.vue"),
      },
      {
        path: "notifications_request_cms/show/:id",
        name: "notifications_request_cms-show",
        meta: {
          title: "Show Notifications CMS",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_request_cms/show.vue"),
      },
      {
        path: "notifications_request_cms/add",
        name: "notifications_request_cms-add",
        meta: {
          title: "Add Notifications CMS",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_request_cms/form.vue"),
      },
      /* ---------------------------- Notification CMS message --------------------------- */
      {
        path: "notification_cms/message/send/:spot_id",
        name: "notification-cms-message-send",
        meta: {
          title: "Send Message",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/notifications_cms/form_message.vue"),
      },
      // HelpOptions
      {
        path: "help_options",
        name: "help_options",
        meta: {
          title: "Opciones de Ayuda",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/help_options/list.vue"),
      },
      {
        path: "help_options/edit/:id",
        name: "help_options-edit",
        meta: {
          title: "Edit Help Option",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/help_options/form.vue"),
      },
      {
        path: "help_options/add",
        name: "help_options-add",
        meta: {
          title: "Add Help Option",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/help_options/form.vue"),
      },

      // Banners
      {
        path: "banners",
        name: "banners",
        meta: {
          title: "Banners",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/banners/list.vue"),
      },
      {
        path: "banners/edit/:id",
        name: "banners-edit",
        meta: {
          title: "Edit Banner",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/banners/form.vue"),
      },
      {
        path: "banners/add",
        name: "banners-add",
        meta: {
          title: "Add Banner",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/banners/form.vue"),
      },

      // Helps
      {
        path: "helps",
        name: "helps",
        meta: {
          title: "Ayuda",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/helps/list.vue"),
      },
      {
        path: "helps/edit/:id",
        name: "helps-edit",
        meta: {
          title: "Edit Help",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/helps/form.vue"),
      },
      {
        path: "helps/add",
        name: "helps-add",
        meta: {
          title: "Add Help",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/helps/form.vue"),
      },


      // Size Spot
      {
        path: "size_spots",
        name: "size_spots",
        meta: {
          title: "Tamaño de Spots",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/size_spots/list.vue"),
      },
      {
        path: "size_spots/edit/:id",
        name: "size_spot-edit",
        meta: {
          title: "Edit Tamaño de Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/size_spots/form.vue"),
      },
      {
        path: "size_spots/add",
        name: "size_spot-add",
        meta: {
          title: "Add Tamaño de Spot",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/size_spots/form.vue"),
      },
      /* ------------------------------ VERIFICARION ------------------------------ */
      {
        path: "verifications/edit/:id",
        name: "verifications-edit",
        meta: {
          title: "Editar Modo de Verificación",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/verifications/form.vue"),
      },
      /* ------------------------------- COMMISSION ------------------------------- */
      {
        path: "commissions/edit/:id",
        name: "commissions-edit",
        meta: {
          title: "Editar Comisión",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/commissions/form.vue"),
      },
      {
        path: "prices/edit/:id",
        name: "prices-edit",
        meta: {
          title: "Set Price Hour",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/prices/form.vue"),
      },
      /* ------------------------------- SETTLEMENT ORDERS CMS------------------------------- */
      {
        path: "request_extraction",
        name: "request_extraction",
        meta: {
          title: "Pedidos de liquidación",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/request_extraction/list.vue"),
      },
      {
        path: "request_extraction/edit/:id",
        name: "request_extraction-edit",
        meta: {
          title: "Editar Pedido de liquidación",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/request_extraction/form.vue"),
      },

      // Cars
      {
        path: "cars",
        name: "cars",
        meta: {
          title: "Autos y Patentes",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/cars/list.vue"),
      },
      {
        path: "cars/edit/:id",
        name: "cars-edit",
        meta: {
          title: "Editar auto",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/cars/form.vue"),
      },
      // {
      //   path: "cars/add",
      //   name: "cars-add",
      //   meta: {
      //     title: "Añadir usuario",
      //     requiresAuth: true,
      //   },
      //   component: () => import("@/views/Admin/cars/form.vue"),
      // },

      // Trakers
      {
        path: "trakers",
        name: "trakers",
        meta: {
          title: "Trakers",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/trakers/list.vue"),
      },
      // Trakers-Spot
      {
        path: "trakers/:spot_id/spot",
        name: "trakers-spot",
        meta: {
          title: "Trakers",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/trakers/spots/list.vue"),
      },

      // Rent Trakers
      {
        path: "rent_trakers",
        name: "rent_trakers",
        meta: {
          title: "Rent Trakers",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/rent_trakers/list.vue"),
      },
      {
        path: 'rent_trakers/:rent_traker_id/messages',
        name: 'rent_traker_messages',
        meta: {
          title: "Conversation",
          requiresAuth: true,
        },
        component: () => import('@/views/Admin/rent_trakers/messages.vue'),
        props: true,
      },

      // Dashboard
      {
        path: "dashboard",
        name: "dashboard",
        meta: {
          title: "Dashboard",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/dashboard/index.vue"),
      },

      // Map
      {
        path: "map",
        name: "map",
        meta: {
          title: "Mapa",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/map/index.vue"),
      },

    ]
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === "production" ? "admin" : "/",
  routes,
});

router.beforeEach((toRoute, fromRoute, next) => {
  window.document.title =
    "Izipark - " +
    (toRoute.meta && toRoute.meta.title ? toRoute.meta.title : "Home");

  if (toRoute.matched.some((record) => record.meta.requiresAuth)) {
    if (authenticate.getters["Authenticate/isLoggedIn"]) {
      next();
      return;
    }
    next("/");
  } else if (
    (toRoute.name === "admin" || toRoute.name === "login") &&
    authenticate.getters["Authenticate/isLoggedIn"]
  ) {
    router.push("/admin/users_scroll");
    return;
  } else {
    next();
  }
});

export default router;
